import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

import { useLogoutAlert } from "@/hooks/use-logout";

import { PAGE_PATHS } from "@/constants";
import { useLogout } from "@/services";
import { useAuthStore } from "@/store";

export const ConfirmLogout = () => {
  const { t } = useTranslation();
  const { isOpen, onClose } = useLogoutAlert();
  const navigate = useNavigate();
  const refreshToken = useAuthStore(state => state.data?.refreshToken);
  const { mutate: logout, isPending } = useLogout();

  function confirmLogout() {
    // Sessiyani serverda ham yopamiz. Ilgari mahalliy holat shu yerda,
    // ya'ni `mutationFn` so'rovni yuborishidan OLDIN tozalanardi: so'rov
    // token'siz ketib 401 olardi va refresh token serverda o'z muddati
    // tugagunicha tirik qolardi. Tozalash endi `useLogout` ning
    // `onSettled` ida — so'rov yakunlangandan keyin.
    logout(refreshToken ?? "");

    onClose();
    navigate(PAGE_PATHS.LOGIN, { replace: true });
    toast.success(t("AUTH.LOGOUT_SUCCESS"));
  }

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("AUTH.LOGOUT_CONFIRMATION")}</AlertDialogTitle>
          <AlertDialogDescription>{t("AUTH.LOGOUT_DESCRIPTION")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose} disabled={isPending}>
            {t("COMMON.CANCEL")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={confirmLogout} disabled={isPending}>
            {t("AUTH.LOGOUT")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
